import Sticky from 'sticky-js';
import 'jquery-visible';
import {library, dom} from '@fortawesome/fontawesome-svg-core';

import {
  faLinkedin,
  faLinkedinIn,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faMailchimp,
  faFacebookSquare,
  faTwitter,
  faTwitterSquare,
  faInstagram,
  faInstagramSquare,
  faPinterest,
  faPinterestP,
  faPinterestSquare,
  faYoutube,
  faYoutubeSquare,
  faSlideshare,
} from '@fortawesome/free-brands-svg-icons';

import {
  faBars,
  faTimes,
  faMinus,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSquare,
  faCopy,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

function returnIdOfVisibleElement(menuConnectedSection) {

  for (let i = 0; i < menuConnectedSection.length; i++) {

    const sectionIdRef = `${menuConnectedSection.eq(i).attr('id')}`;
    const sectionId = `#${sectionIdRef}`;

    const boundaryMargin = 30,
          offsetLowerBoundary = $(sectionId).offset().top - boundaryMargin,
          offsetUpperBoundary = $(sectionId).offset().top + boundaryMargin;

    if (
      ($(window).scrollTop() > offsetLowerBoundary) && ($(window).scrollTop() < offsetUpperBoundary)
      || $(sectionId).visible(true )
    ) {
      return sectionIdRef;
    }
  }

  return null;
}

export default {
  init() {
    // region FONT AWESOME
    library.add(
      faBars,
      faTimes,
      faLinkedin,
      faLinkedinIn,
      faFacebook,
      faTwitter,
      faFacebookMessenger,
      faMailchimp,
      faEnvelope,
      faEnvelopeOpen,
      faEnvelopeOpenText,
      faEnvelopeSquare,
      faCopy,
      faCheck,
      faMinus,
      faFacebookSquare,
      faFacebookF,
      faTwitterSquare,
      faInstagram,
      faInstagramSquare,
      faPinterest,
      faPinterestP,
      faPinterestSquare,
      faYoutube,
      faYoutubeSquare,
      faSlideshare
    );
    dom.watch();
    // endregion

    $('#woocommerce-login-tab').on('click', function (event) {
      event.preventDefault();
      $('#woocommerce-login-tab-container').removeClass('d-none');
      $('#woocommerce-register-tab-container').addClass('d-none');
      $('.woocommerce-form.woocommerce-form-login.login').removeClass('d-none');
      $('.woocommerce-form.woocommerce-form-register.register').addClass('d-none');
    });

    $('#woocommerce-register-tab').on('click', function (event) {
      event.preventDefault();
      $('#woocommerce-register-tab-container').removeClass('d-none');
      $('#woocommerce-login-tab-container').addClass('d-none');
      $('.woocommerce-form.woocommerce-form-login.login').addClass('d-none');
      $('.woocommerce-form.woocommerce-form-register.register').removeClass('d-none');
    });

    $('.copy-txt').on('click', function (event) {
      event.preventDefault();
      const link = $(this);
      const text = link.parent().find('span').first().text();
      navigator.clipboard.writeText(text);
      link.html('<i class="fa fa-check"></i>');
      setTimeout(function () {
        link.html('<i class="fa fa-copy"></i>');
      }, 3000);
    })

    // Initialize Modal
    $('#contact-modal').iziModal({
      height: '100vh',
      width: '100vw',
      zindex: '999999',
    });

    $('.menu-contact').click(() => {
      $('#contact-modal').iziModal('open');
    });

    /* region Product price card description */
    $('.woocommerce__pricing-caption').each(function () {
      $(this).insertBefore($(this).parent().find('a.add_to_cart_button').last());
    });
    /* endregion */

    const licenseSection = $('#woocommerce-licenses');

    if (licenseSection.length) {
      licenseSection.insertAfter(licenseSection.parent().find('section')[1]);
    }

    new Sticky('.case-study-sidebar-container');
  },
  finalize() {

    // JavaScript to be fired on all pages, after page specific JS is fired
    $( document.body ).on( 'click', 'a.showlogin', function (e) {
      window.location.replace('/my-account');
    });

    if (window.location.href.includes('#contact')) {
      $('#contact-modal').iziModal('open');
    }

    const smoothScroll = $('.smooth-scroll');

    if ( smoothScroll[0] ) {

      smoothScroll.on('click', function(event){

        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        let hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        console.log($(hash).offset().top + 20.0);
        $('html, body').animate({
          scrollTop: $(hash + ' h2:first-of-type').offset().top - 40,
        }, 800, function(){

          // Add hash (#) to URL when done scrolling (default click behavior)
         // window.location.hash = hash;
        });
      });
    }

    const menuConnectedSection = $('.menu-connected-section');

    let currentActiveSection = '';

    $(window).scroll(function () {

      const activeSection = returnIdOfVisibleElement(menuConnectedSection);

      if (activeSection && (currentActiveSection != activeSection)) {
        currentActiveSection = activeSection;
        if ($(`#navigation-${activeSection}`).length) {
          $('li').removeClass('active-section');
          $(`#navigation-${activeSection}`).addClass('active-section');
        }
      }

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js